// 退货单详情
import { useState } from 'react'
import { useSetState, useMount } from 'ahooks'
import { PlayOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs'
import { NavBar, List, Toast, Image, ImageViewer, Mask } from 'antd-mobile'
import { useNavigate, useParams } from 'react-router-dom'
import { apis, utils, cal, image as imageUtil } from '@/utils'
import { t } from '@/utils/i18n'
import Icon from '@/components/Icon/Icon';
import { useCorpInfoStore, useCorpSettingStore } from '@/stores'
import OrderReturnDetailItem from '../components/OrderReturnDetailItem'
import type { ProductItem } from '@/types/product'
import type { PageInfo } from '@/types/interfaces'
import localStorage from '@/utils/localStorage'
import type { OrderReturnDetail } from '../types'
import styles from './ReturnDetail.module.less'

const { getLocalStorage } = localStorage
const { orderApi } = apis
const { to } = utils
const { imgFormatter, getVideoSnapshot } = imageUtil

function ReturnDetail() {
  const { corpInfo } = useCorpInfoStore()
  const { corpId } = corpInfo
  const { corpSetting } = useCorpSettingStore()
  const { orderId } = useParams()
  const navigate = useNavigate()
  const [detail, setDetail] = useSetState<OrderReturnDetail>({
    orderId: '',
    createdTime: '',
    orderNo: '',
    totalAmount: 0,
    discountAmount: 0,
    refundableAmount: 0,
    status: -1,
    reason: '',
  })

  const [productList, setProductList] = useState<ProductItem[]>([])
  const [pageInfo] = useSetState<PageInfo>({
    pageNum: 1,
    pageSize: 1000, // 单笔订单最大货品数量
  })
  const [reasonImages, setReasonImages] = useState<string[]>([])
  const [visible, setVisible] = useState(false)
  const [videoSnapshot, setVideoSnapshot] = useState('')
  const [videoUrl, setVideoUrl] = useState('')

  useMount(async () => {
    document.title = t('退货单详情')
    getOrderdDetail()
    getProductList()
  })

  function handleBack() {
    navigate(-1)
  }

  // 获取订单详情
  async function getOrderdDetail() {
    Toast.show({
      icon: 'loading',
      content: 'loading…',
      duration: 0,
    })

    const [err, res] = await to(
      orderApi.queryReturnDetail({
        orderId,
        corpId,
      }),
    )

    Toast.clear()
    if (err) return

    const detailData = res.data || {}
    const { reasonImage } = detailData

    if (reasonImage && reasonImage.length) {
      const list: string[] = []
      const originalList: string[] = []
      const urls: string[] = reasonImage.split(',').filter((item: string) => item)
      ;(async () => {
        for (const imageUrl of urls) {
          let res: string | undefined
          if (imageUrl.indexOf('product_video') === 0 || imageUrl.indexOf('/product_video') === 0) {
            setVideoUrl(`${getLocalStorage('ossRoot')}/${imageUrl}#t=0.1`)
            setVideoSnapshot(getVideoSnapshot(imageUrl, 350))
          } else {
            res = await imgFormatter(imageUrl, 140)
            res && list.push(res)
            originalList.push(`${getLocalStorage('ossRoot')}/${imageUrl}`)
          }
        }
      })()

      detailData.reasonImage = originalList
      setReasonImages(list)
    }

    setDetail({
      ...detailData,
    })
  }

  // 单据货品列表查询
  async function getProductList() {
    const params = {
      ...pageInfo,
      orderId,
      corpId,
    }

    const [err, res] = await to(orderApi.queryReturnProductList(params))

    if (err) {
      return
    }

    const newProducts: ProductItem[] = res.data || []
    const { pageNum } = pageInfo

    // 处理价格
    // newProducts.forEach((item) => {
    //   const isMultiPrice = (item.product.productStatus & 128) === 128

    //   if (!isMultiPrice) {
    //     item.priceText = item.saleProduct.details[0].selectPrice
    //   } else {
    //     // 不同规格不同价格
    //     const { minPrice, maxPrice } = item.saleProduct
    //     item.priceText = minPrice === maxPrice ? minPrice : `${minPrice}~${maxPrice}`
    //   }
    // })

    setProductList(pageNum === 1 ? newProducts : productList.concat(newProducts))
  }

  function getOrderReturnStatusLabel(status: number) {
    switch (status) {
      case 1:
        return t('已确认')
      case 2:
        return t('退货成功')
      default:
        break
    }
  }

  function handleImageViewer(index: number) {
    ImageViewer.Multi.show({
      images: detail.reasonImage,
      defaultIndex: index,
    })
  }

  return (
    <div className={styles['page-wrap']}>
      <NavBar style={{ backgroundColor: '#fff' }} children={t('退货单详情')} onBack={handleBack} />
      <div className={styles['remark-wrap']}>
        <div
          className={`${styles['remark-title']} ${detail.status === 2 ? styles['sussess'] : ''}`}
        >
          {getOrderReturnStatusLabel(detail.status)}
        </div>
        <div className={styles['remark-bd']}>
          <div className={styles['label']}>{t('退货原因')}</div>
          <div className={styles['value']}>
            <p>{detail.reason}</p>
            <div className={styles['img-wrap']}>
              {videoSnapshot && (
                <div className={styles['img-item']} onClick={() => setVisible(true)}>
                  <Image src={videoSnapshot} fit="cover" />
                  <div className={styles['icon-wrap']}>
                    <PlayOutline color='#fff' />
                  </div>
                </div>
              )}
              {detail.reasonImage &&
                reasonImages.map((item, index) => (
                  <div className={styles['img-item']} key={index}>
                    <Image
                      src={item}
                      fit="cover"
                      onClick={() => handleImageViewer(index)}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/*  展示订单详情  */}
      <div className={styles['bill-detail-content']}>
        {/*  列表数据  */}
        <List style={{ '--border-top': 'none' }}>
          <div className={styles['center']}>
            {productList.map((item, index) => (
              <OrderReturnDetailItem
                item={item}
                currencySymbol={corpSetting.currencySymbol}
                key={item.product.productId + index}
              />
            ))}
          </div>
        </List>

        {/* <InfiniteScroll
            hasMore={ hasNextPage }
            finished-text="没有更多了"
            loadMore={ loadNextPage }
            /> */}

        <div className={styles['order-money-info']}>
          <div className={styles['cell-group']}>
            <div className={styles['cell-title']}>
              <span>{t('商品总金额')}</span>
            </div>
            <div className={styles['cell-value']}>
              <span>{corpSetting.currencySymbol}</span>
              <span>{cal.moneyFormat(detail.productAmount)}</span>
            </div>
          </div>
          {/* <div className={styles['cell-group']}>
            <div className={styles['cell-title']}>
              <span>{t('运费')}</span>
            </div>
            <div className={styles['cell-value']}>
              <span>{corpSetting.currencySymbol}</span>
              <span>{cal.moneyFormat(Number(detail.factShippingFee) || 0)}</span>
            </div>
          </div> */}
          {/* {!!detail.codFee && (
            <div className={styles['cell-group']}>
              <div className={styles['cell-title']}>
                <span>{t('COD 服务费')}</span>
              </div>
              <div className={styles['cell-value']}>
                <span>{corpSetting.currencySymbol}</span>
                <span>{cal.moneyFormat(Number(detail.codFee) || 0)}</span>
              </div>
            </div>
          )} */}
          {/* {!!detail.vatFee && (
            <div className={styles['cell-group']}>
              <div className={styles['cell-title']}>
                <span>VAT</span>
              </div>
              <div className={styles['cell-value']}>
                <span>{corpSetting.currencySymbol}</span>
                <span>{cal.moneyFormat(Number(detail.vatFee) || 0)}</span>
              </div>
            </div>
          )} */}

          {/* 优惠 */}
          {!!detail.discountAmount && (
            <div className={styles['cell-group']}>
              <div className={styles['cell-title']}>
                <span>{t('优惠')}</span>
              </div>
              <div className={styles['cell-value']}>
                <span>-{corpSetting.currencySymbol} {cal.moneyFormat(Number(detail.discountAmount) || 0)}</span>
              </div>
            </div>
          )}

          <div className={styles['cell-group']}>
            <span className={styles['cell-title']}>{t('合计')} </span>
            <span className={styles['cell-value']}>
              {corpSetting.currencySymbol} {cal.moneyFormat(detail.totalAmount)}
            </span>
          </div>
          {/* {!!detail.refundableAmount && (
            <div className={styles['order-money-info-ft']}>
              <span className={styles['label']}>{t('实付：')}</span>
              <span className={styles['value']}>
                {corpSetting.currencySymbol} {cal.moneyFormat(detail.refundableAmount)}
                <sub>{`${detail.status === 2 ? t('退款成功') : ''}`}</sub>
              </span>
            </div>
          )} */}
        </div>

        <div className={styles['order-info']}>
          <div className={styles['order-info-title']}>{t('订单信息')}</div>
          <div className={styles['text-item']}>
            <div className={styles['label']}>{t('门店')}</div>
            <div className={styles['value']}>{detail.storeName}</div>
          </div>
          {detail.orderNo ? (
            <div className={styles['text-item']}>
              <div className={styles['label']}>{t('订单号')}</div>
              <div className={styles['value']}>{detail.orderNo}</div>
            </div>
          ) : (
            ''
          )}
          <div className={styles['text-item']}>
            <div className={styles['label']}>{t('交易时间')}</div>
            <div className={styles['value']}>
              {detail.createTime
                ? dayjs(Number(detail.createTime)).format('YYYY-MM-DD HH:mm')
                : '---'}
            </div>
          </div>
          <div className={styles['text-item']}>
            <div className={styles['label']}>
              {t('经手人')}
              {/* Handler */}
            </div>
            <div className={styles['value']}>{detail.followerName}</div>
          </div>
        </div>
      </div>
      <Mask visible={visible} onMaskClick={() => setVisible(false)} opacity={0.9}>
        <div className={styles['mask-warp']}>
          <Icon name='close' color='#fff' size={48} className={styles['close']} onClick={() => setVisible(false)} />
          <video
            src={videoUrl}
            preload="metadata"
            autoPlay
            controls
            controlsList="nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
          ></video>
        </div>
      </Mask>
    </div>
  )
}

export default ReturnDetail
